import React, { useState } from 'react';
import get from 'lodash/get';
import _, { uniqueId } from 'lodash';
import axios from 'axios';
import { SdfAlert, SdfBusyIndicator, SdfButton, SdfFocusPane, SdfIcon, SdfInput } from '@synerg/react-components';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

export default function DeleteProject({ project = {}, onHide }) {
	const [error, setError] = useState('');
	const [loading, setLoading] = useState(false);
	const [isSuccessful, setIsSuccessful] = useState(false);
	const [projectName, setProjectName] = useState('');
	const [isNameEmpty, setIsNameEmpty] = useState(true);
	const history = useHistory();

	const done = () => {
		onHide();
		history.push({ pathname: `/partner-projects` })
	};

	const isValid = projectName.toLowerCase() === get(project, 'projectName', '').toLowerCase();

	const deleteProject = async () => {
		// API call etc
		try {
			// set error state to false to clear out any previous attempt
			setLoading(true);
			setError('');
			// can only delete projects that don't have associated PROD project and call this API for DEV projects only
			if (!project.legacy && project.type === 'DEV' && !project.link) {
				await axios.delete(`${import.meta.env.VITE_ROOT_PATH}/api/project/${project.projectAppId}`);
				setIsSuccessful(true);
			} else if (project.legacy) {
				// make a seperate API call for deleting legacy projects
				await axios.delete(`${import.meta.env.VITE_ROOT_PATH}/api/legacy/project/${project.projectAppId}`);
				setIsSuccessful(true);
			}
		} catch (e) {
			setIsSuccessful(false);
			setError(get(e, 'response.data.message', e.message));
		}
		setLoading(false);
	};

	const onProjectNameChange = (pn) => {
		if (pn.length > 0) {
			setIsNameEmpty(false);
			let p = _.trimStart(pn);
			setProjectName(p);

		} else {
			setIsNameEmpty(true);
		}
	}


	return (
		<div>
			<SdfFocusPane
				paneType="floating"
				visible={true}
				size="md"
				closeable={!(loading || isSuccessful)}
				hideAcceptButton={true}
				hideDismissButton={true}
				onSdfDismiss={onHide}
				heading="Delete Project"
			>
				<div className="px-10">
					{error &&
						<SdfAlert
							key={uniqueId()}
							status={'error'}
							showToast={true}>
							<span slot="title"> Error </span>
							<div>{`Delete Project Failed. ${error}.`}</div>
						</SdfAlert>}

					{!isSuccessful && <p className="text-body-02">Please type in the project name to confirm delete.</p>}
					<div className="delete-label delete-second-line">Delete project will delete all the records you
						have for subscribers to this project.
					</div>

					{isSuccessful &&
						<SdfAlert
							key={uniqueId()}
							status={'success'}
							showToast={true}
							className='mt-6'>
							<span slot="title"> Success </span>
							<div>{`${project.projectName} has been deleted `}</div>
						</SdfAlert>}

					{!isSuccessful && <div className="mt-8 mb-5">
						<div>
							<SdfInput
								label={`Project name: ${project.projectName}`}
								inputWidth="xl"
								state={(!isValid && !isNameEmpty) ? "error" : "normal"}
								placeholder={project.projectName}
								onSdfInput={({ detail }) => { onProjectNameChange(detail) }} />
						</div>

						{isValid && <div className="mt-1 text-body-02 text-alert-success"><SdfIcon icon="alert-success" />&nbsp;Valid</div>}
						{!isValid && !isNameEmpty && <div className="mt-1 text-body-02 text-alert-error"><SdfIcon icon="alert-warning" />&nbsp;Wrong project name</div>}
					</div>}
				</div>

				<div slot={"custom-buttons"} style={{ gap: "1rem" }}>
					<SdfButton {...(loading && { disabled: true })} onClick={isSuccessful ? done : onHide}> {isSuccessful ? 'Done' : 'Cancel'} </SdfButton>
					{!isSuccessful && <SdfButton {...((!isValid || isNameEmpty || loading) && { disabled: true })} emphasis="primary" onClick={deleteProject}>
						<div style={{ height: '1.625rem' }}>
							Delete
							{loading && <SdfBusyIndicator className='relative' style={{ bottom: '1.25rem' }} size='sm' />}
						</div>
					</SdfButton>}
				</div>
			</SdfFocusPane>
		</div>
	);
}
